import _ from 'lodash'

class CurrentUserService {

  constructor($log, $q, $localStorage, UserRole, Base64, $window) {
    this.$log = $log
    this.$q = $q
    this.store = $localStorage
    this.UserRole = UserRole
    this.Base64 = Base64;
    this.$window = $window;
  }

  // Define a getter so this looks and acts more like a $resource
  // even though its wrapping local storage
  get () {
    const deferred = this.$q.defer()
    if ( this.store.user && this.store.user.userId ) {
      deferred.resolve(this.store.user)
    } else {
      deferred.reject(401)
    }

    return deferred.promise;
  }

  isAuthenticated () {
    return current != null
  }

  createReferralLink() {
    return this.$window.location.origin + '/#/?r=' + encodeURIComponent(this.Base64.encode(JSON.stringify({
      referrer_userId: this.store.user.userId,
      referrer_email: this.store.user.email
    })))
  }

  get current() {
    return _.clone(this.store.user)
  }

  set current(user) {
    this.store.user = _.clone(user)
  }

  get roles() {
    return this.store.userRoles
  }

  hasUserRole(roleCode) {
    return this.current && _.some(this.roles, {roleCode: roleCode})
  }

  logout () {
    this.store.user = null
    this.store.userRoles = null
  }

  login (user) {
    this.store.user = user
    this.store.userRoles = this.UserRole.get(
      {userId: user.userId})
  }

}

CurrentUserService.$inject = ['$log', '$q', '$localStorage', 'UserRole', 'Base64', '$window']

export default CurrentUserService
